module.exports = __webpack_public_path__ + "img/30.10dfd8fa.svg";